var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDydx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_4734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3699 6L7 26.1671H11.3838L25.8039 6H21.3699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8712 6.00005L16.1088 11.9435L13.8681 15.1575L7.38849 6.00005H11.8712Z",
    fill: "url(#paint0_linear_800_4734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7598 26.1672L17.0836 19.5915L19.2755 16.4248L26.1923 26.1672H21.7598Z",
    fill: "url(#paint1_linear_800_4734)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_800_4734",
    x1: 10.3044,
    y1: 7.50816,
    x2: 16.2476,
    y2: 14.6205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.549
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_800_4734",
    x1: 22.8488,
    y1: 24.4752,
    x2: 15.4929,
    y2: 14.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_4734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/DYDX.379f534ba6f2067ace2e0090f67052aa.svg";
export { ForwardRef as ReactComponent };